//If not using the auto-generated hooks
// import { FetchArgs, createApi, fetchBaseQuery } from "@reduxjs/toolkit/query";
//If using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'query-string';
import { RootState } from '../../store';

const {
  /** The base URL for the API. */
  VITE_API_BASE_URL,
} = import.meta.env;

const baseQuery = fetchBaseQuery({
  baseUrl: getBaseUrl(),
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState)?.authPersist?.data?.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
  paramsSerializer: (params) => qs.stringify(params, { skipNull: true }),
});

export const api = createApi({
  baseQuery: baseQuery,
  endpoints: () => ({}),
});

function getBaseUrl() {
  const urlObj = new URL(VITE_API_BASE_URL);
  const pathSegments = urlObj.pathname.split('/');
  pathSegments.pop(); // Remove last segment (/api) as the auto generated routes already have this
  urlObj.pathname = pathSegments.join('/');
  const baseUrl = urlObj.toString();
  return baseUrl;
}
